export const clientConstants = {
  REQUEST_START: 'REQUEST_START',
  REQUEST_ERROR: 'REQUEST_ERROR',

  FETCH_BOATS_FOR_CLIENT_SUCCESS: 'FETCH_BOATS_FOR_CLIENT_SUCCESS',

  CREATE_BOAT_ACCESS_LINK_SUCCESS: 'CREATE_BOAT_ACCESS_LINK_SUCCESS',

  FETCH_CLIENT_BY_ID_SUCCESS: 'FETCH_CLIENT_BY_ID_SUCCESS',

  FETCH_ADMIN_CLIENTS_FOR_USER_LOADING: 'FETCH_ADMIN_CLIENTS_FOR_USER_LOADING',
  FETCH_ADMIN_CLIENTS_FOR_USER_SUCCESS: 'FETCH_ADMIN_CLIENTS_FOR_USER_SUCCESS',
  FETCH_ADMIN_CLIENTS_FOR_USER_ERROR: 'FETCH_ADMIN_CLIENTS_FOR_USER_ERROR',

  FETCH_CLIENT_USER_LINKS_ADMIN_SUCCESS: 'FETCH_CLIENT_USER_LINKS_ADMIN_SUCCESS',
  FETCH_CLIENT_USER_LINKS_SUCCESS: 'FETCH_CLIENT_USER_LINKS_SUCCESS',

  FETCH_BOATS_FOR_ACCESS_GROUP_SUCCESS: 'FETCH_BOATS_FOR_ACCESS_GROUP_SUCCESS',

  SAVING_NEW_CLIENT_USER_LINK_SUCCESS: 'SAVING_NEW_CLIENT_USER_LINK_SUCCESS',

  SAVING_NEW_USER_SUCCESS: 'SAVING_NEW_USER_SUCCESS',

  FETCH_CLIENT_ACCESS_GROUPS_SUCCESS: 'FETCH_CLIENT_ACCESS_GROUPS_SUCCESS',

  CREATE_NEW_CLIENT_ACCESS_GROUP_SUCCESS: 'CREATE_NEW_CLIENT_ACCESS_GROUP_SUCCESS',

  CREATE_NEW_BOAT_USER_LINK_SUCCESS: 'CREATE_NEW_BOAT_USER_LINK_SUCCESS',

  FETCH_BOAT_USER_LINKS_SUCCESS: 'FETCH_BOAT_USER_LINKS_SUCCESS',
}
